import React, { ReactElement } from 'react';
import { CaseProps } from './Case';
import { isCase, isDefault } from './utilities';
import { DefaultProps } from './Default';

export interface SwitchProps {
  on: any;
  children: (ReactElement<CaseProps> | ReactElement<DefaultProps>)[];
}

export function Switch(props: SwitchProps) {
  let children = props.children;

  if (!children) {
    children = [];
  }

  let defaultCase = null;
  for (const child of props.children) {
    if (isCase(child)) {
      if (child.props.when === props.on) {
        return child;
      }
    } else if (isDefault(child)) {
      defaultCase = child;
    }
  }

  if (defaultCase) {
    return defaultCase;
  }

  return <></>;
}
